import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { setTokenHeader, getJwtFromCookies, basePort, getUsernameJwt, headers, isExpiredJwt, parseJwt, queryParameters, renderRedirect } from "../../module_auth/AuthService"
import { Pagination } from "../../component/common/Pagination"
import { useNavigate } from "react-router-dom"
import { PersonCardMypage } from "./PersonCardMypage"
import { isValidSearchPage } from '../common/BaseUtil';

export function PersonListMypage() {

    const [objectList, setObjectList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [mbrId, setMbrId] = useState("");

    const navigate = useNavigate();

    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    ////pagination

    const [cityList, setCityList] = useState([]);

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            //alert
            setRedirect(true)
        } else {
            setRedirect(false)
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            getCityList()
            //currentPage
            let currentPage
            if(!isValidSearchPage(page)){
                let localStoragePage = localStorage.getItem("page")
                currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
            } else {
                currentPage = page == "0" ? "1" : page
            }
            //end currentPage

            navigate("/person_list_mypage?page="  + currentPage);
            localStorage.setItem("page", currentPage)
            
            let url = basePort + '/get/persons/mypage/' + currentPage
            let activePageIndex = (currentPage-1)%2
            if(next != null){
                url = basePort + '/get/persons/mypage/next/' + currentPage
                activePageIndex = (currentPage-1)%2
            } else if(previous != null) {
                url = basePort + '/get/persons/mypage/previous/' + currentPage
                activePageIndex = (currentPage-1)%2
            }
            
            setTokenHeader(getJwtFromCookies())
            fetch(url, 
            {method:'GET', headers,
                body:JSON.stringify()})
                .then(response => response.json())
                .then(response => {
                setObjectList(response.cardList)
                
                ////pagination
                setPageList(response.displayPages)
                setLastPage(response.lastPage)
                setActivePageIndex(activePageIndex)
                ////pagination

            }).catch(error => console.log(error))
        }}, []);

    function getCityList(){
        let url = basePort + '/get/config'
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
               console.log(response.cityEntityList)
               setCityList(response.cityEntityList)
          }).catch(error => console.log(error))
    }
    
    function clickRegister() {
        let url = "/person_reg_select"
        navigate(url);
    }
    
    return (
        <div>
            {renderRedirect(redirect, '/person_reg_mypage')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <div class="row" style={{display: 'flex'}}>
                    <div class="col-md-6 d-md-flex justify-content-xl-center align-items-xl-center justify-content-xxl-center">
                        <p class="d-flex justify-content-center justify-content-md-center align-items-xxl-center" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px', marginTop: '15px'}}>인재정보</p>
                    </div>
                    <div class="col-md-6 d-flex d-md-flex justify-content-center justify-content-md-center align-items-md-center"><button class="btn btn-primary btn-sm text-end" type="button" style={{borderRadius: '5px'}} onClick={clickRegister}>등록</button></div>
                </div>
                    </div>
                    <div class="container">
                        {objectList.map((object, index) => (
                            <PersonCardMypage cityList={cityList} object={object} index={index} key={index} returnTo={"/person_list_mypage"}/>
                        ))}
                    </div>
                    <Pagination 
                        lastPage={lastPage}
                        page={page}
                        pageList={pageList}
                        activePageIndex={activePageIndex}
                    />
                </section>
            </main>
        </div>
    );
    }